import React from 'react';
import Layout from '../components/layout';
import Main from '../components/main';

const IndexPage = ({ location }) => {
	return (
		<Layout location={location}>
			<Main />
		</Layout>
	)
}

export default IndexPage;
